var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    { attrs: { title: _vm.title, loading: _vm.loading } },
    [
      _c(
        "sc-tabs",
        {
          staticClass: "page-xml-cte-tags__tabs",
          attrs: { type: "is-boxed has-form", animated: false }
        },
        [
          _c(
            "sc-tab-item",
            { attrs: { label: "Nova Tag" } },
            [_c("sc-from-to-xml-cte")],
            1
          ),
          _vm._v(" "),
          _c(
            "sc-tab-item",
            { attrs: { label: "Upload" } },
            [
              _c("sc-file-import"),
              _vm._v(" "),
              _c("div", { staticClass: "box" }, [_c("sc-file-import-table")], 1)
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-717281f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-717281f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/xml-cte-tags/PageXmlCteTags.vue
// module id = null
// module chunks = 